module.exports = __webpack_public_path__ + "img/icn-03.3f7465ec.png";